/* import __COLOCATED_TEMPLATE__ from './custom-action-set-live-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();